import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ShieldQuarter = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M20.995 6.9a.998.998 0 00-.548-.795l-8-4a1 1 0 00-.895 0l-8 4a1.002 1.002 0 00-.547.795c-.011.107-.961 10.767 8.589 15.014a.987.987 0 00.812 0c9.55-4.247 8.6-14.906 8.589-15.014zM12 19.897V12H5.51a15.473 15.473 0 01-.544-4.365L12 4.118V12h6.46c-.759 2.74-2.498 5.979-6.46 7.897z",
    key: "k0"
  }));
});
ShieldQuarter.displayName = 'ShieldQuarter';
export var ShieldQuarterDimensions = {
  height: 24,
  width: 24
};